import React, { useContext } from 'react';
import { CalculationResult } from './CalculationResult/CalculationResult';
import { PriceCalculationContext } from '../PriceCalculationContext';
import { Sidebar } from '../../Sidebar/Sidebar';
import { Loader } from '../../../molecules/Loader/Loader';

function CalculationSidebar() {
    const {
        sidebarData,
        activeStepName,
        calculationIsLoadingText,
        cartUrl,
        resourcedTexts,
        conditionalProductsIsLoadingText,
        fixedAmountIsLoadingText,
    } = useContext(PriceCalculationContext);

    const showCalculationLoader = Boolean(calculationIsLoadingText);
    const showFixedAmountLoader = Boolean(fixedAmountIsLoadingText);
    const showConditionalProductsLoader = Boolean(conditionalProductsIsLoadingText);

    return (
        <Sidebar sidebarData={sidebarData} stepName={activeStepName} fullHeight={false} maxHeight={true}>
            {activeStepName === 'CalculationResult' && <CalculationResult />}

            {activeStepName === 'CalculationFinished' && (
                <div className="calculation-sidebar-button-wrapper">
                    <a href={cartUrl} className="button primary">
                        {resourcedTexts.goToCart}
                    </a>
                </div>
            )}

            {showFixedAmountLoader && <Loader text={fixedAmountIsLoadingText} />}

            {showCalculationLoader && <Loader text={calculationIsLoadingText} />}

            {showConditionalProductsLoader && <Loader text={conditionalProductsIsLoadingText} />}
        </Sidebar>
    );
}

export { CalculationSidebar };
